module.exports = __webpack_public_path__ + "media/LightLogo.d4cf716d.svg";